"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reference = void 0;
const typesTemplates = {
    'digest': (ref) => `${ref.digest}`,
    'canonical': (ref) => `${ref.repositoryUrl}@${ref.digest}`,
    'repository': (ref) => `${ref.repositoryUrl}`,
    'tagged': (ref) => `${ref.repositoryUrl}:${ref.tag}`,
    'dual': (ref) => `${ref.repositoryUrl}:${ref.tag}@${ref.digest}`
};
class Reference {
    get tag() {
        return this._tag;
    }
    get digest() {
        return this._digest;
    }
    get repository() {
        return this._repository;
    }
    get domain() {
        return this._domain;
    }
    get type() {
        return this._type;
    }
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        if (!options.repository && !options.domain) {
            if (options.digest) {
                this._digest = options.digest;
                this._type = 'digest';
            }
            else {
                throw new TypeError('Empty Reference');
            }
        }
        else if (!options.tag) {
            this._domain = (_a = options.domain) !== null && _a !== void 0 ? _a : '';
            this._repository = (_b = options.repository) !== null && _b !== void 0 ? _b : '';
            if (options.digest) {
                this._digest = options.digest;
                this._type = 'canonical';
            }
            else {
                this._type = 'repository';
            }
        }
        else if (!options.digest) {
            this._domain = (_c = options.domain) !== null && _c !== void 0 ? _c : '';
            this._repository = (_d = options.repository) !== null && _d !== void 0 ? _d : '';
            this._tag = options.tag;
            this._type = 'tagged';
        }
        else {
            this._domain = (_e = options.domain) !== null && _e !== void 0 ? _e : '';
            this._repository = (_f = options.repository) !== null && _f !== void 0 ? _f : '';
            this._tag = options.tag;
            this._digest = options.digest;
            this._type = 'dual';
        }
    }
    toString() {
        return typesTemplates[this._type](this);
    }
    get repositoryUrl() {
        if (this._domain && this._repository) {
            return `${this._domain}/${this._repository}`;
        }
        return '';
    }
}
exports.Reference = Reference;
//# sourceMappingURL=reference.js.map